/* globals hideFromAnchor history $ */

import { ready } from './cegep.utils'

// js-tabs
function tabs () {
  // For easy reference
  var keys = {
    enter: 13,
    space: 32
  }

  // custom focus to avoid browser scroll to element
  function cursorFocus (elem) {
    // retrieve current scroll position
    var scrollTopCurrent = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop

    // set focus
    elem.focus()

    // scroll back to previous position (this is a seamless execution)
    window.scrollTo(0, scrollTopCurrent)
  }

  // deactivate all tabs
  function deactivateTabs ($container) {
    var $tabs = $container.find('.js-tab-trigger')
    var $panels = $container.find('[role="tabpanel"]')

    $tabs.removeClass('active')
    $tabs.attr('aria-selected', 'false')
    $panels.hide()
    $panels.attr('hidden', 'hidden')
  };

  // activate any given tab panel
  function activateTab ($container, $tab, setFocus, updateHash) {
    if ($tab.length <= 0 || $container.length <= 0) {
      return
    }
    var targetId = $tab.attr('aria-controls')
    var $panel = $container.find('#' + targetId)

    if ($panel.length <= 0) {
      return
    }

    // deactivate all tabs
    deactivateTabs($container)

    // Set the tab as selected
    $tab.addClass('active')
    $tab.attr('aria-selected', 'true')

    // Show tabpanel, remove its hidden attribute and set focus to it
    $panel.removeAttr('hidden')
    $panel.show()

    if (setFocus) {
      cursorFocus($panel[0])
    }

    if (updateHash) {
      var hash = '#' + $tab.attr('aria-controls')
      var currentLocation = window.location.toString()

      if (currentLocation.indexOf('#') === -1) {
        history.replaceState({ path: window.path }, '', currentLocation + hash)
      } else {
        history.replaceState({ path: window.path }, '', currentLocation.split('#')[0] + hash)
      }

      // call to global function
      if (typeof hideFromAnchor === 'function') {
        hideFromAnchor()
      }
    }
  };

  // init all tabs element
  $('.js-tabs').each(function () {
    // variables
    var $container = $(this)
    var $tab = null
    var requestedHash = ((window.location.hash.substring(1).split('#', 1)) + '?').split('?', 1)

    // if relevant hash in URL, activate relevant tab
    if (requestedHash != '' && $container.find('#' + requestedHash).length > 0) {
      $tab = $container.find('.js-tab-trigger[aria-controls="' + requestedHash + '"]')
      activateTab($container, $tab, false, false)
    } else {
      // activate first tab
      $tab = $container.find('.js-tab-trigger:first')
      activateTab($container, $tab, false, false)
    }
  })

  // click listener
  $('.js-tab-trigger').click(function () {
    // variables
    var $container = $(this).closest('.js-tabs')
    var $tab = $(this)

    // activate new tab
    activateTab($container, $tab, false, true)
  })

  // keyup listener
  $('.js-tab-trigger').keyup(function (event) {
    if (event.keyCode != keys.enter && event.keyCode != keys.space) {
      return
    }

    // variables
    var $container = $(this).closest('.js-tabs')
    var $tab = $(this)

    // activate new tab
    activateTab($container, $tab, true, true)
  })
}

ready(tabs)
